<template>
  <div v-scroll="handleScroll" :class="className">
    <slot />
  </div>
</template>

<script>
import { getWindowHeight, getScrollHeight, getScrollPosition } from '@/utils/scroll'
export default {
  props: {
    processing: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ''
    },
    isLoadmore: {
      type: Boolean,
      default: false
    },
    handler: {
      type: Function,
      default: () => {
        console.log('handler')
      }
    }
  },
  methods: {
    handleScroll(event) {
      const scrollPosition = getScrollPosition() || event.srcElement.body.scrollTop + (document.documentElement && (document.documentElement.scrollTop || 0))
      if (this.isLoadmore && getWindowHeight() < scrollPosition + getScrollHeight() + 1500) {
        if (!this.processing) {
          this.handler()
        }
      }
    }
  }
}
</script>
